import { ReactComponent as LogoFilledFull } from "../Icons/LogoFilledFull.svg";
import { Button, ButtonGroup, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { theme } from "../../theme";

type FooterProps = {
  showLogo?: boolean;
};
const Footer = ({ showLogo = true }: FooterProps) => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <div className="flex flex-col items-center bg-white dark:bg-background/paper-elevation-1 mt-auto pt-2">
      {showLogo && (
        <div className="flex items-center justify-center pb-6">
          <LogoFilledFull className="text-black dark:text-white" />
          <h2 className="text-xl font-semibold ml-3 text-black dark:text-white">TradeGPT</h2>
        </div>
      )}
      <ButtonGroup color="inherit" orientation="horizontal" variant="text" className="flex-nowrap">
        <Button
          size={isMobile ? "small" : "medium"}
          className="button-link !border-mui-black-12 dark:!border-mui-white-12 whitespace-nowrap"
          onClick={() => navigate("/policies/service-terms")}
        >
          Terms of Service
        </Button>
        <Button
          size={isMobile ? "small" : "medium"}
          className="button-link !border-mui-black-12 dark:!border-mui-white-12 whitespace-nowrap"
          onClick={() => navigate("/policies/privacy-policy")}
        >
          Privacy Policy
        </Button>
        <Button
          size={isMobile ? "small" : "medium"}
          className="button-link whitespace-nowrap"
          onClick={() => navigate("/policies/legal-disclaimer")}
        >
          Legal Disclaimer
        </Button>
      </ButtonGroup>
    </div>
  );
};

export default Footer;
